import { Component, OnInit, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NotesService } from '../../services/notes/notes.service';

@Component({
  selector: 'app-view-approval-history',
  templateUrl: './view-approval-history.component.html',
  styleUrls: ['./view-approval-history.component.scss'],
  providers: [NotesService]
})
export class ViewApprovalHistoryComponent implements OnInit {
  @Input() history;
  @Input() req_id;
  @Input() approval_id;
  @Input() transaction_id;
  constructor(
    private status_svc: NotesService,
    private dialogRef: MatDialogRef<ViewApprovalHistoryComponent>,
  ) {
    // this.history=
  }

  // history;
  //   current_status;
  //   req_id;


  ngOnInit(): void {
    // this.history = null;
    //   this.history = [
    //     [
    //         {
    //             "user_id": "2",
    //             "name": "Anya Browne",
    //             "approval_status": 0,
    //             "status": 0
    //         },
    //         {
    //             "user_id": "3",
    //             "name": "Carolyn Warrington",
    //             "approval_status": 0,
    //             "status": 0
    //         }
    //     ],
    //     [
    //         {
    //             "user_id": 7,
    //             "name": "Emil Maravilla",
    //             "approval_status": 1000,
    //             "approval_status_title": "Approved",
    //             "status": 2
    //         },
    //         {
    //             "user_id": 6,
    //             "name": "Debra Coady"
    //         }
    //     ]
    // ]


    this.getApprovalHistory();
  }

  getApprovalHistory() {

    this.status_svc.getApprovalHistory({
      id: this.req_id, approval_id: this.approval_id, transaction_id: this.transaction_id, lng_id: 1, type: 1
    }).subscribe(res => {
      if (res && res['status']) {
        // if (res['data'] && res['data']['req_status']) {
        //   this.req_status = res['data']['req_status']
        // }
        if (res['data'] && res['data']['approval_history']) {
          this.history = res['data']['approval_history']

        }
        //   this.history = [
        //     [
        //         {
        //             "user_id": "2",
        //             "name": "Anya Browne",
        //             "approval_status": 0,
        //             "status": 0
        //         },
        //         {
        //             "user_id": "3",
        //             "name": "Carolyn Warrington",
        //             "approval_status": 0,
        //             "status": 0
        //         }
        //     ],
        //     [
        //         {
        //             "user_id": 7,
        //             "name": "Emil Maravilla",
        //             "approval_status": 1000,
        //             "approval_status_title": "Approved",
        //             "status": 2
        //         },
        //         {
        //             "user_id": 6,
        //             "name": "Debra Coady"
        //         }
        //     ]
        // ]

        // if (res && res['data'] && res['data'].details && res['data'].details.current_status_code) {
        //   this.req_status_form.patchValue({status: res['data'].details.current_status_code})
        // }

      }
    })
  }
  close() {
    this.dialogRef.close();
  }
}
